/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { WhitepaperYearsDto } from '../../models/whitepaper-years-dto';

export interface GetAvailableWhitepaperYears$Params {
}

export function getAvailableWhitepaperYears(http: HttpClient, rootUrl: string, params?: GetAvailableWhitepaperYears$Params, context?: HttpContext): Observable<StrictHttpResponse<WhitepaperYearsDto>> {
  const rb = new RequestBuilder(rootUrl, getAvailableWhitepaperYears.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<WhitepaperYearsDto>;
    })
  );
}

getAvailableWhitepaperYears.PATH = '/api/whitepaper/years';
